<script>
export default {
  name: "ReportTerminalsHyperLink",
  functional: true,
  props: {
    row: Object,
    column: String,
    OpenTerminalsDetail: Function
  },
  render: function (createElement, context) {
    const col = context.props.column;
    const val = context.props.row[col];
    let clase = String;

    switch (col) {
      case "CantTotalTerminales":
        clase = "blue bold";
        break;

      case "CantTeminalesActivas":
        clase = "green bold";
        break;

      case "CantTeminalesInactivas":
        clase = "red bold";
        break;
      case "CantContactsWithApp":
        clase = "green bold";
        break;

      case "CantContactsWithoutApp":
        clase = "red bold";
        break;

      case "CantTotalContacts":
        clase = "blue bold";
        break;
    }

    return createElement(
      "a",
      {
        attrs: {
          name: "",
          href: "#",
          class: clase
        },
        on: {
          click: () => {
            const { row, OpenTerminalsDetail } = context.props;
            OpenTerminalsDetail(row, col);
          }
        }
      },

      val > 0 ? val : ""
    );
  }
};
</script>

<style scoped>
.bold {
  font-weight: bold;
  font-size: 17px;
}
.red {
  color: red;
}
.green {
  color: green;
}
.blue {
  color: blue;
}
</style>
